import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// core components
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Slide from "@material-ui/core/Slide";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Check from "@material-ui/icons/Check";
import Close from "@material-ui/icons/Close";

import PropTypes from "prop-types";
import stylesAlert from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";
import stylesModal from "assets/jss/material-dashboard-pro-react/views/notificationsStyle.js";
import stylesCheckbox from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";

import axios from "axios";

import { cardTitle } from "assets/jss/material-dashboard-pro-react.js";

import SweetAlert from "react-bootstrap-sweetalert";
import { useHistory } from "react-router-dom";
import * as Constants from "constants.js";
//import { Link } from "react-router-dom";

axios.defaults.withCredentials = true;

const { REACT_APP_SERVER_URL } = process.env;

const stylesCard = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px",
    textAlign: "left",
  },
};

const stylesSize = {
  size: {
    fontSize: "large",
    color: "black",
    opacity: 1,
    textAlign: "left",
  },
};

const stylesList = {
  list: {
    display: "inline",
    padding: "5px",
  },
};

const styleHeading = {
  heading: {
    fontWeight: "bold",
    textAlign: "center",
  },
};

const alertOverrides = {
  marginTop: "-100px",
  marginRight: "0px",
  marginBottom: "0px",
  marginLeft: "0px",
};

const useStylesCheckbox = makeStyles(stylesCheckbox);
const useStylesAlert = makeStyles(stylesAlert);
const useStylesModal = makeStyles(stylesModal);

const useStylesCard = makeStyles(stylesCard);
const useStylesList = makeStyles(stylesList);
const useStylesHeading = makeStyles(styleHeading);
const useStylesSize = makeStyles(stylesSize);

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

export default function ConferenceRegistration(props) {
  const classesAlert = useStylesAlert();
  const classesCard = useStylesCard();
  const classesList = useStylesList();
  const classesCheckbox = useStylesCheckbox();
  const classesModal = useStylesModal();
  const classesHeading = useStylesHeading();
  const classesSize = useStylesSize();

  const classes = {
    ...classesAlert,
    ...classesModal,
    ...classesCard,
    ...classesList,
    ...classesCheckbox,
    ...classesHeading,
    ...classesSize,
  };

  const [alert, setAlert] = React.useState(null);
  const [name, setName] = React.useState(props.userInfo.name);
  const [conference, setConference] = React.useState("");
  const [institution, setInstitution] = React.useState("");
  const [agendaTopic, setAgendaTopic] = React.useState("");
  const [agendaTime, setAgendaTime] = React.useState("");
  const [roleTypeNumeric, setRoleTypeNumeric] = React.useState("1");
  const [regTypeNumeric, setRegTypeNumeric] = React.useState("1");
  const [needTimeNumeric, setNeedTimeNumeric] = React.useState("1");
  const [affiliation, setAffiliation] = React.useState([]);
  const [agreement, setAgreement] = React.useState([]);

  const [registrationModal, setRegistrationModal] = React.useState(false);

  const currentPreventMeeting = Constants.CURRENT_MEETING; // NEED to update this with current meeting

  const history = useHistory();
  const goToMyConferences = () => {
    let path = `/portal/my_conferences`;
    history.push(path);
  };

  const handleAffiliation = (value) => {
    const currentIndex = affiliation.indexOf(value);
    const newAffiliation = [...affiliation];

    if (currentIndex === -1) {
      newAffiliation.push(value);
    } else {
      newAffiliation.splice(currentIndex, 1);
    }
    setAffiliation(newAffiliation);
  };

  const allFormsValid = () => {
    if (
      name &&
      name.length > 0 &&
      institution &&
      institution.length > 0 &&
      roleTypeNumeric > 1 &&
      regTypeNumeric > 1 &&
      agreement.length > 0 &&
      (needTimeNumeric != 2 ||
        (agendaTopic.length > 0 && agendaTime.length > 0))
    ) {
      return false;
    }
    return true;
  };

  const handleAgreement = (value) => {
    const currentIndex = agreement.indexOf(value);
    const newAgreement = [...agreement];

    if (currentIndex === -1) {
      newAgreement.push(value);
    } else {
      newAgreement.splice(currentIndex, 1);
    }
    setAgreement(newAgreement);
  };

  const hideAlert = () => {
    setAlert(null);
  };

  const handleSetRegistrationModal = (conference) => {
    setConference(conference);
    setRegistrationModal(true);
  };

  const successAddRegistration = () => {
    setAlert(
      <SweetAlert
        success
        style={alertOverrides}
        title="Success!"
        onConfirm={() => {
          hideAlert();
          setRegistrationModal(false);
          goToMyConferences();
        }}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + " " + classes.success}
      >
        You have been registered! You will be redirected to your conferences
        page!
      </SweetAlert>
    );
  };

  const successUpdateRegistration = () => {
    setAlert(
      <SweetAlert
        success
        style={alertOverrides}
        title="Success!"
        onConfirm={() => {
          hideAlert();
          setRegistrationModal(false);
          goToMyConferences();
        }}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + " " + classes.success}
      >
        Registration has been updated! You will be redirected to your
        conferences page!
      </SweetAlert>
    );
  };

  const failUpdateRegistration = (errorMessage) => {
    setAlert(
      <SweetAlert
        danger
        style={alertOverrides}
        title={errorMessage ? errorMessage : "Something Went Wrong!"}
        onConfirm={() => {
          hideAlert();
        }}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + " " + classes.danger}
      >
        {name} has NOT been updated!
      </SweetAlert>
    );
  };

  const cancelUpdateUser = () => {
    setAlert(
      <SweetAlert
        danger
        style={alertOverrides}
        title="Cancelled"
        onConfirm={() => hideAlert()}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + " " + classes.success}
      >
        Registration not Updated!
      </SweetAlert>
    );
  };

  const confirmUpdateRegistration = (postValues) => {
    setAlert(
      <SweetAlert
        warning
        style={alertOverrides}
        title="You are already registered for this conference. Would you like to update your registration with these values?"
        onConfirm={() => handleSubmitUpdateRegistration(postValues)}
        onCancel={() => cancelUpdateUser()}
        confirmBtnCssClass={classes.button + " " + classes.success}
        cancelBtnCssClass={classes.button + " " + classes.danger}
        confirmBtnText="Yes, Update Registration"
        cancelBtnText="Cancel"
        showCancel
      >
        Registration will be Updated
      </SweetAlert>
    );
  };

  const handleSubmitAddRegistration = async (e) => {
    e.preventDefault();

    const roleTypeCode =
      roleTypeNumeric == 2
        ? "md"
        : roleTypeNumeric == 3
        ? "phd"
        : roleTypeNumeric == 4
        ? "rn"
        : roleTypeNumeric == 5
        ? "rcp"
        : "student";

    const regTypeCode = regTypeNumeric == 2 ? "in_person" : "virtual";

    const affiliationCode = affiliation.map((item) => {
      if (item == 1) {
        return "palicc";
      }
      if (item == 2) {
        return "vent_lib";
      }
    });
    const needTimeCode = needTimeNumeric == 2 ? true : false;

    const agreementCode = agreement[0] == 1 ? true : false;

    const email = props.userInfo && props.userInfo.email;

    let postValues = {
      conference_name: conference,
      name: name,
      institution: institution,
      email: email,
      role: roleTypeCode,
      registration_type: regTypeCode,
      affiliation: affiliationCode,
      agreement: agreementCode,
      need_time: needTimeCode,
      agenda_topic: agendaTopic,
      agenda_time: agendaTime,
    };

    if (conference == "palicc_prevent_symposium_2022") {
      postValues.need_time = false;
      postValues.agenda_topic = "";
      postValues.agenda_time = "";
    }

    if (conference == currentPreventMeeting) {
      postValues.affiliation = [];
    }

    let addRegistration;
    /////NEED to change update profile route to see if user exists and if not create a new user.
    try {
      addRegistration = await axios.post(
        `${REACT_APP_SERVER_URL}/registrations`,
        {
          ...postValues,
        },
        {
          withCredentials: true,
        }
      );
    } catch ({ response }) {
      addRegistration = response;
    }
    if (addRegistration.status == 200) {
      successAddRegistration();
      getRegistrations();
    } else if (
      addRegistration.data.messages.databaseError ==
      "The email has already been taken."
    ) {
      confirmUpdateRegistration(postValues);
    } else {
      failUpdateRegistration(addRegistration.data.messages.databaseError);
    }
  };

  const handleSubmitUpdateRegistration = async (postValues) => {
    const email = props.userInfo && props.userInfo.email;
    const findEmailIndex = (item) => {
      return (
        item.email == email &&
        item.conference_name == postValues.conference_name
      );
    };

    const emailIndex = props.registrations.findIndex(findEmailIndex);

    const registrationID =
      props.registrations[emailIndex] && props.registrations[emailIndex].id;

    let updateRegistration;

    /////NEED to change update profile route to see if user exists and if not create a new user.
    try {
      updateRegistration = await axios.put(
        `${REACT_APP_SERVER_URL}/registrations/${registrationID}`,
        {
          ...postValues,
        },
        {
          withCredentials: true,
        }
      );
    } catch ({ response }) {
      updateRegistration = response;
    }
    if (updateRegistration.status == 200) {
      successUpdateRegistration();
      getRegistrations();
    } else {
      failUpdateRegistration(updateRegistration.data.messages.databaseError);
    }
  };

  async function getRegistrations() {
    props.reloadRegistrationsCallBack(true);
  }

  const { userInfo } = props;
  const access = userInfo.access;

  return (
    <div>
      {alert}

      <Dialog
        classes={{
          root: classes.center + " " + classes.modalRoot,
          paper: classes.modal,
        }}
        open={registrationModal}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => setRegistrationModal(false)}
        aria-labelledby="notice-modal-slide-title"
        aria-describedby="notice-modal-slide-description"
      >
        <DialogTitle
          id="notice-modal-slide-title"
          disableTypography
          className={classes.modalHeader}
        >
          <Button
            justIcon
            className={classes.modalCloseButton}
            key="close"
            aria-label="Close"
            color="transparent"
            onClick={() => {
              setRegistrationModal(false);
            }}
          >
            <Close className={classes.modalClose} />
          </Button>
          <h4 className={classes.modalTitle}>Registration</h4>
        </DialogTitle>
        <DialogContent
          id="notice-modal-slide-description"
          className={classes.modalBody}
        >
          <div className={classes.modalBody}>
            <GridContainer>
              <GridItem xs={12} sm={12} md={12}>
                <form onSubmit={handleSubmitAddRegistration}>
                  <GridItem xs={12} sm={12} md={12}>
                    <CustomInput
                      labelText="Name *"
                      id="name"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        value: name,
                        onChange: (event) => {
                          setName(event.target.value);
                        },
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12}>
                    <CustomInput
                      labelText="Institution *"
                      id="institution"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        value: institution,
                        onChange: (event) => {
                          setInstitution(event.target.value);
                        },
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12}>
                    <FormControl
                      fullWidth
                      className={classes.selectFormControl}
                    >
                      <InputLabel
                        htmlFor="simple-select"
                        className={classes.selectLabel}
                      >
                        Select Role *
                      </InputLabel>
                      <Select
                        MenuProps={{
                          className: classes.selectMenu,
                        }}
                        classes={{
                          select: classes.select,
                        }}
                        inputProps={{
                          name: "simpleSelect",
                          id: "roleTypeNumeric",
                          value: roleTypeNumeric,
                          onChange: (event) => {
                            setRoleTypeNumeric(event.target.value);
                          },
                        }}
                      >
                        <MenuItem
                          disabled
                          classes={{
                            root: classes.selectMenuItem,
                          }}
                        >
                          Select Type
                        </MenuItem>
                        <MenuItem
                          classes={{
                            root: classes.selectMenuItem,
                            selected: classes.selectMenuItemSelected,
                          }}
                          value="2"
                        >
                          MD/DO
                        </MenuItem>
                        <MenuItem
                          classes={{
                            root: classes.selectMenuItem,
                            selected: classes.selectMenuItemSelected,
                          }}
                          value="3"
                        >
                          PhD
                        </MenuItem>
                        <MenuItem
                          classes={{
                            root: classes.selectMenuItem,
                            selected: classes.selectMenuItemSelected,
                          }}
                          value="4"
                        >
                          RN
                        </MenuItem>
                        <MenuItem
                          classes={{
                            root: classes.selectMenuItem,
                            selected: classes.selectMenuItemSelected,
                          }}
                          value="5"
                        >
                          RCP
                        </MenuItem>
                        <MenuItem
                          classes={{
                            root: classes.selectMenuItem,
                            selected: classes.selectMenuItemSelected,
                          }}
                          value="6"
                        >
                          Student
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12}>
                    <FormControl
                      fullWidth
                      className={classes.selectFormControl}
                    >
                      <InputLabel
                        htmlFor="simple-select"
                        className={classes.selectLabel}
                      >
                        Select Registration Type *
                      </InputLabel>
                      <Select
                        MenuProps={{
                          className: classes.selectMenu,
                        }}
                        classes={{
                          select: classes.select,
                        }}
                        inputProps={{
                          name: "simpleSelect",
                          id: "regTypeNumeric",
                          value: regTypeNumeric,
                          onChange: (event) => {
                            setRegTypeNumeric(event.target.value);
                          },
                        }}
                      >
                        <MenuItem
                          disabled
                          classes={{
                            root: classes.selectMenuItem,
                          }}
                        >
                          Select Type
                        </MenuItem>
                        <MenuItem
                          classes={{
                            root: classes.selectMenuItem,
                            selected: classes.selectMenuItemSelected,
                          }}
                          value="2"
                        >
                          In Person
                        </MenuItem>
                        <MenuItem
                          classes={{
                            root: classes.selectMenuItem,
                            selected: classes.selectMenuItemSelected,
                          }}
                          value="3"
                        >
                          Virtual
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </GridItem>

                  {conference == currentPreventMeeting && (
                    <GridItem xs={12} sm={12} md={12}>
                      <FormControl
                        fullWidth
                        className={classes.selectFormControl}
                      >
                        <InputLabel
                          htmlFor="simple-select"
                          className={classes.selectLabel}
                        >
                          Do you want time on the agenda? *
                        </InputLabel>
                        <Select
                          MenuProps={{
                            className: classes.selectMenu,
                          }}
                          classes={{
                            select: classes.select,
                          }}
                          inputProps={{
                            name: "simpleSelect",
                            id: "needTimeNumeric",
                            value: needTimeNumeric,
                            onChange: (event) => {
                              if (event.target.value == 3) {
                                setAgendaTime("");
                                setAgendaTopic("");
                              }
                              setNeedTimeNumeric(event.target.value);
                            },
                          }}
                        >
                          <MenuItem
                            disabled
                            classes={{
                              root: classes.selectMenuItem,
                            }}
                          >
                            Select Type
                          </MenuItem>
                          <MenuItem
                            classes={{
                              root: classes.selectMenuItem,
                              selected: classes.selectMenuItemSelected,
                            }}
                            value="2"
                          >
                            Yes
                          </MenuItem>
                          <MenuItem
                            classes={{
                              root: classes.selectMenuItem,
                              selected: classes.selectMenuItemSelected,
                            }}
                            value="3"
                          >
                            No
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </GridItem>
                  )}

                  {needTimeNumeric == "2" && (
                    <div>
                      <GridItem xs={12} sm={12} md={12}>
                        <CustomInput
                          labelText="Title of Topic *"
                          id="agendaTopic"
                          formControlProps={{
                            fullWidth: true,
                          }}
                          inputProps={{
                            value: agendaTopic,
                            onChange: (event) => {
                              setAgendaTopic(event.target.value);
                            },
                          }}
                        />
                      </GridItem>
                      <GridItem xs={12} sm={12} md={12}>
                        <CustomInput
                          labelText="Number of minutes requested *"
                          id="agendaTime"
                          formControlProps={{
                            fullWidth: true,
                          }}
                          inputProps={{
                            value: agendaTime,
                            onChange: (event) => {
                              setAgendaTime(event.target.value);
                            },
                            type: "number",
                          }}
                        />
                      </GridItem>
                    </div>
                  )}

                  {conference == "palicc_prevent_symposium_2022" && (
                    <GridItem xs={12} sm={12} md={12}>
                      <div
                        className={
                          classes.checkboxAndRadio +
                          " " +
                          classes.checkboxAndRadioHorizontal
                        }
                      >
                        <FormControlLabel
                          control={
                            <Checkbox
                              tabIndex={-1}
                              onClick={() => handleAffiliation(1)}
                              checkedIcon={
                                <Check className={classes.checkedIcon} />
                              }
                              icon={<Check className={classes.uncheckedIcon} />}
                              classes={{
                                checked: classes.checked,
                                root: classes.checkRoot,
                              }}
                            />
                          }
                          classes={{
                            label: classes.label,
                            root: classes.labelRoot,
                          }}
                          label="Affiliated with PALICC"
                        />
                      </div>
                      <div
                        className={
                          classes.checkboxAndRadio +
                          " " +
                          classes.checkboxAndRadioHorizontal
                        }
                      >
                        <FormControlLabel
                          control={
                            <Checkbox
                              tabIndex={-1}
                              onClick={() => handleAffiliation(2)}
                              checkedIcon={
                                <Check className={classes.checkedIcon} />
                              }
                              icon={<Check className={classes.uncheckedIcon} />}
                              classes={{
                                checked: classes.checked,
                                root: classes.checkRoot,
                              }}
                            />
                          }
                          classes={{
                            label: classes.label,
                            root: classes.labelRoot,
                          }}
                          label="Affiliated with Vent Liberation"
                        />
                      </div>
                    </GridItem>
                  )}
                  <GridItem xs={12} sm={12} md={12}>
                    <FormControlLabel
                      classes={{
                        root: classes.checkboxLabelControl,
                        label: classes.checkboxLabel,
                      }}
                      control={
                        <Checkbox
                          tabIndex={-1}
                          onClick={() => handleAgreement(1)}
                          checkedIcon={
                            <Check className={classes.checkedIcon} />
                          }
                          icon={<Check className={classes.uncheckedIcon} />}
                          classes={{
                            checked: classes.checked,
                            root: classes.checkRoot,
                          }}
                        />
                      }
                      label={
                        <span>
                          I agree to the{" "}
                          <a href="/portal/agreement" target="_blank">
                            confidentiality agreement
                          </a>
                          .
                        </span>
                      }
                    />
                  </GridItem>
                  <Button
                    color="info"
                    className={classes.updateProfileButton}
                    type="submit"
                    disabled={allFormsValid()}
                  >
                    Register!
                  </Button>
                </form>
              </GridItem>
            </GridContainer>
          </div>
        </DialogContent>
        <DialogActions
          className={classes.modalFooter + " " + classes.modalFooterCenter}
        >
          <Button
            onClick={() => {
              setRegistrationModal(false);
            }}
            color="rose"
            round
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
      {/* <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card profile>
            <CardBody profile>
              <div className={classes.size}>
                <b>
                  <h3 className={classes.heading}>
                    Pediatric ARDS and Ventilator Liberation Symposium
                  </h3>
                </b>
                <div>
                  <h5 className={classes.center}>
                    The Pediatric Respiratory and VENTilation (PREVENT) subgroup
                    of the PALISI network, in conjunction with the Pediatric
                    Ventilator Liberation Guidelines and the Pediatric Acute
                    Lung Injury Consensus Conference Update (PALICC-2) project
                    would like to announce a symposium focused on pediatric ARDS
                    and ventilator liberation.
                  </h5>
                  <br></br>
                  <h4 className={classes.heading}>Dates</h4>

                  <h5 className={classes.center}>
                    March 31-April 1, 2022, concluding mid-day April 1, 2022
                  </h5>

                  <h4 className={classes.heading}>Location</h4>

                  <h5 className={classes.center}>
                    Loews Coronado Bay Resort, San Diego, CA
                  </h5>

                  <h4 className={classes.heading}>Topics</h4>

                  <h5 className={classes.center}>
                    Updates and preliminary findings from PALICC-2 and Vent
                    Liberation Projects. Research priorities in Pediatric ARDS
                    and Ventilator Liberation. Development of protocol templates
                    and key elements for Pediatric ARDS and Ventilation
                    Research.
                  </h5>

                  <h4 className={classes.heading}>Registration Fee</h4>

                  <h5 className={classes.center}>Free</h5>

                  <h4 className={classes.heading}>Registration Link</h4>

                  <h5 className={classes.center}>
                    All participants must be pre-registered by March 15, 2022 to
                    attend.{" "}
                  </h5>
                  <br></br>
                </div>
              </div>

              <Link
                to="/files/SymposiumPrelimAgenda.pdf"
                target="_blank"
                download
              >
                <Button
                  style={{ fontSize: "large" }}
                  color="info"
                  className={classes.updateProfileButton}
                >
                  Download Agenda
                </Button>
              </Link>
              <br></br>

              <Button
                style={{ fontSize: "large" }}
                color="info"
                className={classes.updateProfileButton}
                disabled={access <= 2}
                onClick={() => {
                  handleSetRegistrationModal("palicc_prevent_symposium_2022");
                }}
              >
                {access <= 2 ? "Must be Logged in to Register!" : "Register!"}
              </Button>
              <br></br>
              <br></br>
              <h5>
                Supported by funding from the Eunice Kennedy Shriner National
                Institute of Child Health and Development (NICHD) and National
                Heart Lung and Blood Institute (NHLBI) . 1 R13 HD102137
              </h5>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer> */}
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card profile>
            <CardBody profile>
              <div className={classes.size}>
                <b>
                  <h3 className={classes.heading}>PREVENT Meeting</h3>
                </b>
                <div>
                  <h5 className={classes.center}>
                    Spring 2024 PREVENT Meeting
                  </h5>
                  <br></br>
                  <h4 className={classes.heading}>Date/Time</h4>

                  <h5 className={classes.center}>
                    March 1st 2024 at 13:45 AST
                  </h5>

                  <h4 className={classes.heading}>Location</h4>

                  <h5 className={classes.center}>
                    Puerto Rico (In-Person) and Virtual Meeting
                  </h5>
                  <br></br>
                </div>
              </div>
              {/* <Link
                to="/files/PreventMeetingAgenda.pdf"
                target="_blank"
                download
              >
                <Button
                  style={{ fontSize: "large" }}
                  color="info"
                  className={classes.updateProfileButton}
                >
                  Download Agenda
                </Button>
              </Link> */}
              <br></br>

              <Button
                style={{ fontSize: "large" }}
                color="info"
                className={classes.updateProfileButton}
                disabled={access <= 2}
                onClick={() => {
                  handleSetRegistrationModal(currentPreventMeeting);
                }}
              >
                {access <= 2 ? "Must be Logged in to Register!" : "Register!"}
              </Button>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}

ConferenceRegistration.propTypes = {
  userInfo: PropTypes.Object,
  registrations: PropTypes.Object,
  users: PropTypes.Object,
  reloadRegistrationsCallBack: PropTypes.func,
};
